<template>
  <div class="editable-page-model-h5-24" :style="{backgroundColor:editablePageConfig.editable_page_config_content.back_color,paddingTop:editablePageConfig.editable_page_config_content.margin_top,paddingBottom:editablePageConfig.editable_page_config_content.margin_bottom}">
    <div class="new_arrivals">
      <div class="new_arrivals_bt" v-if="editablePageConfig.editable_page_config_content.text[0].list[0]">
        <div class="h3">
          {{ editablePageConfig.editable_page_config_content.text[0].list[0].content }}
        </div>
      </div>
      <div class="new_arrivals_con">
        <div class="new_arrivals_scroller">
          <div class="new_arrivals_section">
            <div
                v-for="(item, index) in editablePageConfig.goods_list[0]"
                v-bind:key="index"
                class="new_arrivals_item"
                @click="productClick(item.goods_id)"
              >
              <a class="a-link-normal" href="javascript:void(0);">
                <div class="a-image-container">
                  <img
                    class="product-icon"
                    v-bind:src="item.goods_image_url"
                  />
                </div>
                <div class="a-spacing-top-base">
                  <div class="a-row">
                    <span><span>{{currency}} {{ item.goods_promotion_price }}</span></span>
                  </div>
                </div>
                <div class="a-desc">
                  {{ item.goods_name }}
                </div>
              </a>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import {mapState} from "vuex";

export default {
  name: 'Model24',
  data () {
    return {
    }
  },
  props: ['editablePageConfig'],
  computed: {
    ...mapState({
      currency: state => state.currency.currency
    })
  },
  methods: {
    productClick(goods_id) {
      this.$router.push({ name: 'HomeGoodsdetail', query: { goods_id: goods_id } })
    }
  }
}
</script>

<style lang="scss" scoped>
.editable-page-model-h5-24 .new_arrivals {
  padding: 0.6rem 0.5rem 0 0;
  background: #eaeded;
  direction: rtl;
}
.editable-page-model-h5-24 .new_arrivals_bt {
  text-align: right;
  padding-right: 5px;
}
.editable-page-model-h5-24 .new_arrivals_bt .h3 {
  font-weight: 700;
  font-size: 16px;
  line-height: 1.25;
  color: #0F1111 !important;
}
.editable-page-model-h5-24 .new_arrivals_con {
  margin-top: 8px;
  padding: 0;
  position: relative;
  font-size: 15px;
  /*margin-left: -15px;
  margin-right: -15px;*/
}
.editable-page-model-h5-24 .new_arrivals_scroller {
  width: 100%;
  height: 100%;
  overflow: auto;
  -webkit-overflow-scrolling: touch;
  overflow-y: hidden;
}
.editable-page-model-h5-24 .new_arrivals_section {
  display: -webkit-inline-box;
  display: -ms-inline-flexbox;
  display: inline-flex;
  /*margin-right: 15px;*/
}
.editable-page-model-h5-24 .new_arrivals_item {
  background-color: #fff;
  border-radius: 4px 4px 0 0;
  margin: 0 0 0 8px;
  padding: 8px 8px 12px;
  position: relative;
  width: 200px;
  box-sizing: border-box;
}
.editable-page-model-h5-24 .new_arrivals_item:after {
  background: rgba(15, 17, 17, .03);
  content: "";
  height: 180px;
  left: 0;
  pointer-events: none;
  position: absolute;
  top: 0;
  width: 200px;
}
.editable-page-model-h5-24 .new_arrivals_item .a-image-container {
  position: relative;
  height: 164px
}
.editable-page-model-h5-24 .new_arrivals_item .a-image-container img {
  position: absolute;
  margin: auto;
  top: 0;
  left: 0;
  bottom: 0;
  right: 0;
  max-width: 100%;
  max-height: 100%;
}
.editable-page-model-h5-24 .new_arrivals_item .a-spacing-top-base {
  margin-top: 1.2rem !important;
}
.editable-page-model-h5-24 .new_arrivals_item .a-spacing-top-base .a-row {
  width: 100%;
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-align: center;
  -ms-flex-align: center;
  align-items: center;
  margin-bottom: 4px;
}
.editable-page-model-h5-24 .new_arrivals_item .a-spacing-top-base .a-row > span {
  border-radius: 2px;
  font-weight: 400;
  line-height: 12px;
  padding: 4px 0px;
  position: relative;
  margin-right: 0;
  background-color: #ffffff;
  color: #e93b3d
}
.editable-page-model-h5-24 .new_arrivals_item .a-desc {
  height: 40px;
  line-height: 20px;
  color: #0F1111;
  overflow:hidden;
  display:-webkit-box;
  text-overflow:ellipsis;
  -webkit-line-clamp:2;
  -webkit-box-orient:vertical;
}
</style>
